import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme } = getTheme();

export const styles = {
    roomResult: css({
        display: 'flex',
        width: '100%',
        maxWidth: '1240px',
        minHeight: '500px',
        margin: '0 auto 60px',
        padding: '0 20px',

        [theme.breakpoints.down('lg')]: {
            minHeight: '400px',
        },

        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            minHeight: 'auto',
            padding: 0,
        },
    }),

    gallery: css({
        position: 'relative',
        width: '75%',
        height: '500px',

        [theme.breakpoints.down('lg')]: {
            height: '400px',
        },

        [theme.breakpoints.down('md')]: {
            width: '100%',
            height: '420px',
        },

        [theme.breakpoints.down('sm')]: {
            height: '300px',
        },
    }),

    carouselImage: css({
        display: 'block',
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: 'center',
        margin: 0,
    }),

    carouselButton: css({
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '2.5rem',
        width: '2.5rem',
        height: '2.5rem',
        padding: 0,
        borderRadius: 0,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        fontSize: '60px',
        zIndex: 4,
        lineHeight: 1,

        '&:hover': {
            outline: `1px solid ${theme.palette.primary.main}`,
        },

        '& .MuiSvgIcon-root': {
            fontSize: '42px',
        },

        [theme.breakpoints.down('sm')]: {
            width: '46px',
            height: '46px',
            minWidth: '46px',
            fontSize: '36px',
        },
    }),

    carouselButtonPrevious: css({
        left: '-30px',

        [theme.breakpoints.down('md')]: {
            left: '10px',
        },

        '& span': {
            transform: 'translateY(-2px)',
        },
    }),

    carouselButtonNext: css({
        right: '10px',

        [theme.breakpoints.up('md')]: {
            left: '15px',
            right: 'auto',
        },

        '& span': {
            transform: 'translateY(-2px)',
        },
    }),

    progressBar: css({
        position: 'absolute',
        width: '45%',
        left: '3.9375rem',
        bottom: '-0.84375rem',
        height: '.84375rem',
        backgroundColor: theme.palette.primary.light,
    }),

    roomCard: css({
        position: 'relative',
        width: '25%',
        zIndex: 2,

        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
    }),

    card: css({
        boxSizing: 'border-box',
        width: 'calc(100% + 75px)',
        marginLeft: '-75px',
        padding: '15px',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.common.white,
        boxShadow: `0 3px 10px ${theme.palette.grey[500]}`,
        position: 'relative',
        zIndex: 2,

        [theme.breakpoints.down('md')]: {
            width: '100%',
            marginLeft: 0,
        },
    }),

    title: css({
        margin: 0,
        textAlign: 'left',
    }),

    titleUnderline: css({
        width: '50px',
        height: '2px',
        margin: '15px 0',
        backgroundColor: theme.palette.common.black,
    }),

    field: css({
        display: 'flex',
        flexDirection: 'column',
    }),

    label: css({
        width: 'fit-content',
        margin: '0 0 -7px 12px',
        padding: '0 5px',
        position: 'relative',
        zIndex: 1,
        fontSize: '13px',
        lineHeight: 1,
        textAlign: 'left',
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.common.white,
    }),

    select: css({
        height: '3.65625rem',
        borderRadius: '8px',

        '& .MuiSelect-select': {
            display: 'flex',
            alignItems: 'center',
            padding: '16px 44px 12px 14px',
            fontSize: '14px',
            color: theme.palette.text.primary,
            textAlign: 'left',
        },

        '& .MuiOutlinedInput-notchedOutline': {
            border: `1px solid ${theme.palette.grey[500]}`,
        },

        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.common.black,
        },

        '& .MuiSelect-icon': {
            right: '14px',
        },
    }),

    divider: css({
        width: '100%',
        margin: '9px 0',
        borderColor: theme.palette.grey[400],
    }),

    detailRow: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    }),

    bottomRow: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',

        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            alignItems: 'stretch',
            gap: '8px',
        },
    }),

    price: css({
        [theme.breakpoints.down('md')]: {
            textAlign: 'left',
        },
    }),

    viewButton: css({
        minWidth: '110px',
        borderRadius: '24px',
        fontSize: '16px',
        fontWeight: 700,
        textTransform: 'uppercase',

        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
    }),
};
